export default {"src":"/_next/static/media/calendar.689b2ebd.svg","height":88,"width":96,"blurWidth":0,"blurHeight":0};